<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <v-row
      class="alternatingContentRow pa-0"
    >
    </v-row>
    <v-row
      class="alternatingContentRow my-8"
    >
      <v-col
        class="center"
        cols="12"
        lg="10"
      >
        <h2
          class="colorPrimary text-center"
        >
          Rouwdrukwerk
        </h2>
        <p
          class="text-center"
        >
          U kan een gedichtje kiezen of zich laten inspireren.
        </p>
      </v-col>
    </v-row>
    <v-row
      class="alternatingContentRow my-8 py-8"
    >
      <v-col
        class="center"
        cols="12"
        lg="10"
      >
        <h2
          class="text-center"
        >
          1. Hoofding rouwbrief
        </h2>
      </v-col>
      <v-col
        class="center mt-5"
        cols="12"
        lg="6"
      >
        <v-row>
          <v-col
            v-for="(item, index) in PageList('hoofdingen')"
            :key="index"
            class="px-10 pt-5"
            :class="item.idRouwbriefhoofding === data.idRouwbriefhoofding ? 'elementSelected' : ''"
            cols="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                lg="12"
              >
                <span
                  class="colorPrimary volgnummer"
                >
                  {{item.volgnummer}}
                </span>
                <p
                  style="white-space: pre-line"
                >
                  {{ item.tekst }}
                  <br>
                  <span
                    class="font-italic"
                  >
                    {{ item.auteur }}
                  </span>
                </p>
              </v-col>
              <v-col
                cols="6"
                lg="8"
              >
                <div
                  style="border-bottom: 1px solid #AAAAAA; margin-top: 35px;"
                />
              </v-col>
              <v-col
                cols="6"
                lg="4"
              >
                <v-btn
                  block
                  color="primary"
                  :disabled="item.idRouwbriefhoofding === data.idRouwbriefhoofding"
                  tile
                  @click="SelecteerHoofding(item)"
                  >
                  Kies
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          v-if="PageCount('hoofdingen') > 1"
          justify="center"
        >
          <v-col
            class="my-8 py-8"
            cols="12"
            lg="8"
          >
            <v-pagination
              v-model="filters.hoofdingen.page"
              color="primary"
              :length="PageCount('hoofdingen')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="mt-3"
            cols="12"
            lg="12"
          >
            <v-textarea
              v-model="data.rouwbriefhoofdingOpmerking"
              auto-grow
              base-color="primary"
              bg-color="white"
              color="primary"
              density="compact"
              label="Opmerking"
              variant="outlined"
            />
            <v-btn
              color="primary"
              tile
              @click="SelecteerHoofding(data)"
              >
              Opslaan
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      class="alternatingContentRow my-8 py-8"
    >
      <v-col
        class="center"
        cols="12"
        lg="10"
      >
        <h2
          class="text-center"
        >
          2. Tekst prentje
        </h2>
      </v-col>
      <v-col
        class="center mt-5"
        cols="12"
        lg="6"
      >
        <v-row>
          <v-col
            v-for="(item, index) in PageList('teksten')"
            :key="index"
            class="px-10 pt-5"
            :class="item.idPrentjeTekst === data.idPrentjeTekst ? 'elementSelected' : ''"
            cols="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                lg="12"
              >
                <span
                  class="colorPrimary volgnummer"
                >
                  {{item.volgnummer}}
                </span>
                <p
                  style="white-space: pre-line"
                >
                  {{ item.tekst }}
                  <br>
                  <span
                    class="font-italic"
                  >
                    {{ item.auteur }}
                  </span>
                </p>
              </v-col>
              <v-col
                cols="6"
                lg="8"
              >
                <div
                  style="border-bottom: 1px solid #AAAAAA; margin-top: 35px;"
                />
              </v-col>
              <v-col
                cols="6"
                lg="4"
              >
                <v-btn
                  block
                  color="primary"
                  :disabled="item.idPrentjeTekst === data.idPrentjeTekst"
                  tile
                  @click="SelecteerPrentjeTekst(item)"
                  >
                  Kies
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          v-if="PageCount('teksten') > 1"
          justify="center"
        >
          <v-col
            class="my-8 py-8"
            cols="12"
            lg="8"
          >
            <v-pagination
              v-model="filters.teksten.page"
              color="primary"
              :length="PageCount('teksten')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="mt-3"
            cols="12"
            lg="12"
          >
            <v-textarea
              v-model="data.prentjeTekstOpmerking"
              auto-grow
              base-color="primary"
              bg-color="white"
              color="primary"
              density="compact"
              label="Opmerking"
              variant="outlined"
            />
            <v-btn
              color="primary"
              tile
              @click="SelecteerPrentjeTekst(data)"
              >
              Opslaan
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authenticationMixin from '@/mixins/authenticationMixin'
import errorMixin from '@/mixins/errorMixin'
import klantService from '@/services/klantService'

export default {
  name: 'RouwdrukwerkComponent',
  mixins: [
    authenticationMixin,
    errorMixin,
  ],
  data () {
    return {
      data: {
        hoofdingen: [],
        teksten: []
      },
      filters: {
        hoofdingen: {
          numberPerPage: 4,
          page: 1
        },
        teksten: {
          numberPerPage: 4,
          page: 1
        }
      }
    }
  },
  async mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    klantService.Init(this)
    this.$store.state.headers.samenstellen = true
    await this.GetRouwbriefhoofdingList(true)
    await this.GetPrentjeTekstList(true)
  },
  beforeUnmount () {
    this.$store.state.headers.samenstellen = false
  },
  methods: {
    async GetPrentjeTekstList (setPage) {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartPrentjeTekstList()

      if (resp && (resp.data || resp.data !== '')) {
        this.data = {
          ...this.data,
          ...this.CommonMixin_Clone(resp.data)
        }

        if (setPage) {
          const itemIndex = this.data.teksten.findIndex(item => 
            item.idPrentjeTekst === this.data.idPrentjeTekst
          )

          if (itemIndex !== -1) {
            const pageNumber = Math.ceil((itemIndex + 1) / this.filters.teksten.numberPerPage);
            this.filters.teksten.page = pageNumber;
          } else {
            this.filters.teksten.page = 1
          }
        }
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetRouwbriefhoofdingList (setPage) {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartRouwbriefhoofdingList()

      if (resp && (resp.data || resp.data !== '')) {
        this.data = {
          ...this.data,
          ...this.CommonMixin_Clone(resp.data)
        }

        if (setPage) {
          const itemIndex = this.data.hoofdingen.findIndex(item => 
            item.idRouwbriefhoofding === this.data.idRouwbriefhoofding
          )

          if (itemIndex !== -1) {
            const pageNumber = Math.ceil((itemIndex + 1) / this.filters.hoofdingen.numberPerPage);
            this.filters.hoofdingen.page = pageNumber;
          } else {
            this.filters.hoofdingen.page = 1
          }
        }
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    PageList (subtype) {
      return this.CommonMixin_GetPageList(this.data[subtype], this.filters[subtype].page, this.filters[subtype].numberPerPage)
    },
    PageCount (subtype) {
      return this.CommonMixin_GetPageCount(this.data[subtype], this.filters[subtype].numberPerPage)
    },
    async SelecteerHoofding (rouwbriefhoofding) {
      this.CommonMixin_Load(this.$options.name, true)
      this.data.idRouwbriefhoofding = rouwbriefhoofding.idRouwbriefhoofding
      await klantService.SaveUitvaartRouwbriefhoofding(this.data)
      await this.GetRouwbriefhoofdingList()
      this.CommonMixin_Load(this.$options.name, false)
    },
    async SelecteerPrentjeTekst (rouwbriefhoofding) {
      this.CommonMixin_Load(this.$options.name, true)
      this.data.idPrentjeTekst = rouwbriefhoofding.idPrentjeTekst
      await klantService.SaveUitvaartPrentjeTekst(this.data)
      await this.GetPrentjeTekstList()
      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>
